function withCtxResponseRedirect() {
  return ctx => {
    // if (ctx.res) {
    //     ctx.res.redirect = function redirect(...args) {
    //         let address = args[0];
    //         let status = 302;
    //         if (args.length === 2) {
    //             [status, address] = args;
    //         }
    //         // use the HTTP response to
    //         // redirect with the status code
    //         ctx.res.writeHead(status, { Location: address });
    //         ctx.res.end();
    //     };
    // }
  };
}

export { withCtxResponseRedirect };
